import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FormContext } from '../../shared/contexts/form-context';
import { selectFormDesign } from '../../form/selectors';
import { formStyles } from '../../../shared/utils';
import {
  GreenLeafImg,
  OrangeLeafImg,
  DefaultButton,
  SubmissionText,
  CreateFormText,
  PostSubmissionText,
  CreateFormContainer,
  SubmittedFormContainer,
  PostSubmissionFormContainer, 
} from './form-pagination.styled';

const FormTimeTriggeredSubmission = ({ isQuizTimeUp, isEventTimeUp, foundEmptyForm, eventFormNoSubmission }) => {
  const { inBuilder, PLAN } = useContext(FormContext);
  const formDesign = useSelector((state) => selectFormDesign(state));
  const { is_free, is_trial } = PLAN || {};


  return (
    <PostSubmissionFormContainer
    // formPageStyles={!inBuilder && formStyles(formDesign)}
    >
      <SubmittedFormContainer none>
        {(isQuizTimeUp || (isEventTimeUp && !eventFormNoSubmission && !foundEmptyForm)) && (
          <img src="https://storage.googleapis.com/fplsblog/post_submission_checkmark.svg" alt="" />
        )}
        <PostSubmissionText>{isQuizTimeUp ? "Time's up!" : 'This form is now closed'}</PostSubmissionText>
        <SubmissionText submitted>
          {isEventTimeUp && foundEmptyForm && 'There was no data to submit.'}
          {isEventTimeUp && eventFormNoSubmission && 'Your responses will not be submitted.'}
          {(isQuizTimeUp || (isEventTimeUp && !eventFormNoSubmission && !foundEmptyForm)) &&
            'Your response has been submitted automatically.'}
        </SubmissionText>
      </SubmittedFormContainer>

      {(is_free || is_trial) && (
        <CreateFormContainer>
          <CreateFormText>
            Create your own online survey, forms, and other documents in the <span>easy-to-use </span>Formplus builder
          </CreateFormText>
          <DefaultButton>
            <a href="https://formpl.us/?utm_source=formplus_form&utm_medium=post-submission">Create a form for free</a>
          </DefaultButton>
        </CreateFormContainer>
      )}

      {/* <GreenLeafImg src="https://storage.googleapis.com/fplsblog/green-leaf.svg" alt="green-leaf" />
      <OrangeLeafImg src="https://storage.googleapis.com/fplsblog/orange-leaf.svg" alt="orange-leaf" /> */}
    </PostSubmissionFormContainer>
  );
};

FormTimeTriggeredSubmission.defaultProps = {
  isQuizTimeUp: false,
  isEventTimeUp: false,
  foundEmptyForm: false,
  eventFormNoSubmission: false,
};

FormTimeTriggeredSubmission.propTypes = {
  foundEmptyForm: PropTypes.bool,
  isQuizTimeUp: PropTypes.bool,
  isEventTimeUp: PropTypes.bool,
  eventFormNoSubmission: PropTypes.bool,
};

export default FormTimeTriggeredSubmission;
